<template>
    <div class="container">
        <div class="footer">
            <div class="col-md-6">
                <div class="row">
                    <div :style="{ '--color' : footer.non_repeat.headline_color }"
                         class="col-xs-12 col-md-12 headline_color no-padding">
                        <div id="footerHeadline" class="headline" v-html="footer.non_repeat.headline"></div>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-xs-12 col-md-12 no-padding">
                        <div id="footerDescription" v-html="footer.non_repeat.text"></div>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-xs-12 col-md-12 no-padding">
                        <div id="footerSteps" class="steps" v-html="footer.non_repeat.steps"></div>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-xs-12 col-md-12 info no-padding">
                        <img id="footerInfoImage" :data-src="footer.non_repeat.image" class="footer-image lazy">
                        <div id="footerInfoText" class="info-text" v-html="footer.non_repeat.info"></div>
                    </div>
                </div>
                <div class="row" v-if="footer.non_repeat.buttontext !==''">
                    <div class="col-xs-12 col-md-12 button_position" id="footer-btn">
                        <a :href=footer.non_repeat.buttonlink class="btn btn-primary col-xs-12 col-md-6">
                            <p class="footer_button" v-html="footer.non_repeat.buttontext"></p>
                        </a>
                    </div>
                </div>
                      <div class="row extra_button" id="extra-btn" v-if="footer.non_repeat.buttontext !==''">
                        <a :href=footer.non_repeat.buttonlink>
                            <p class="second-btn" v-html="footer.non_repeat.buttontext"></p>
                        </a>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "FooterSection",
  props: ['footer']
}
</script>

<style scoped lang="scss">

@import "../../css/variables.scss";

.footer-image{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-right: 50px;
  margin-bottom: 15px;
  margin-top: 10px;
}
.info{
  display: flex;
  line-height: 10px;
}
.info p{
  margin-top: 30px;
}
.extra_button{
  text-align: center;
  border: 1px solid white;
  border-radius: 5px;
  font-weight: 600;
  margin: 13px auto 20px auto;
  display: flex;
  justify-content: center;
  width: 200px;
}
.second-btn{
  color: #ffffff;
  margin-top: 10px;
}
.footer_button{
  height: 14px;
  text-align: center;
  margin-top: 10px;
}
.button_position{
  float: right;
  margin-bottom: 10px;
}
.footer{
  color: #FFFFFF;

  .col-md-6 {
    padding: 0;

    @media (min-width: $sm-breakpoint-min) {
      padding: 0 30px;
    }
  }
}
.info-text {
  line-height: 22px;
  margin-top: 10px;
  align-self: center;
}
@media (min-width: 992px) {
  .footer{
    margin-left: 60px;
  }
  .footer_button {
    height: 24px;
  }
  .extra_button{
    display: none;
  }
}
</style>
